import jQuery from "jquery";
import {ZIDX, ZIDXPage} from "../../../standalone/standaloneLibrary.js";
const $ = jQuery.noConflict();
export class ZIDXAccountPayment implements ZIDXPage{
    zidx:ZIDX;
    constructor(zidx:ZIDX) {
        this.zidx = zidx;
    }
    getPageClass(){
        return "zidxAccountPaymentContainer";
    }
    render(){
        let self=this;
        // console.log("payment");
        $("#defaultCardButton", this.zidx.peakidxShadowRoot).on("click", function(e:Event) {
            e.preventDefault();
            $(".zidxAccountPaymentContainer #paymentAction", self.zidx.peakidxShadowRoot).val(1);
            $(".zidxAccountPaymentContainer .zidxForm", self.zidx.peakidxShadowRoot).trigger("submit");
        });
        $("#deleteCardButton", this.zidx.peakidxShadowRoot).on("click", function(e:Event) {
            e.preventDefault();
            $(".zidxAccountPaymentContainer #paymentAction", self.zidx.peakidxShadowRoot).val(2);
            $(".zidxAccountPaymentContainer .zidxForm", self.zidx.peakidxShadowRoot).trigger("submit");
        });
    }
}